import type { SessionsTour } from '@carboncopyco/data';
import { TextBase } from '@carboncopyco/ui';
import { integersFormatter, secondsToHHmmss } from '@carboncopyco/utils';
import type { Col } from '../../../FixedTable';
import { PreviewTourButton } from './PreviewTourButton';
import { RowChevron } from './RowChevron';
import { TourName } from './TourName';

export const getCols = (isInModal?: boolean): Col<SessionsTour>[] => [
  {
    alignment: 'left',
    title: 'Tour name',
    width: 320,
    maxContentWidth: 290,
    render: ({ asset }) => (
      <TourName
        asset={asset}
        isInModal={isInModal}
      />
    ),
  },
  {
    alignment: 'right',
    title: 'Visits',
    width: 100,
    render: (tour) => {
      return (
        <TextBase
          label={integersFormatter(tour.totalVisits)}
          color="text-ds-natural-600"
        />
      );
    },
  },
  {
    alignment: 'right',
    title: 'Median duration',
    width: 150,
    render: (tour) => (
      <TextBase
        label={secondsToHHmmss(tour.medianDuration)}
        color="text-ds-natural-600"
      />
    ),
  },
  {
    alignment: 'right',
    title: 'Completion rate',
    width: 150,
    render: (tour) => (
      <TextBase
        label={`${tour.completionRate.toFixed()}%`}
        color="text-ds-natural-600"
      />
    ),
  },
  {
    alignment: 'right',
    title: 'Bounce rate',
    width: 150,
    render: (tour) => (
      <TextBase
        label={`${tour.bounceRate.toFixed()}%`}
        color="text-ds-natural-600"
      />
    ),
  },
  {
    alignment: 'right',
    title: '',
    width: 150,
    render: ({ asset }) => <PreviewTourButton asset={asset} />,
  },
  {
    alignment: 'right',
    title: '',
    width: 100,
    render: ({ asset }) => <RowChevron asset={asset} />,
  },
];
